import { useCallback } from 'react';

import type { SidekickActingOrganizationScope } from '../api/actingOrganization';
import { useConversationServiceDiscardConversationMutation } from '../api/overrides';

/**
 * Deletes a backend conversation that could not be committed to local chat
 * state. Cleanup is best-effort so the original edit outcome stays primary.
 * @returns A stable asynchronous cleanup callback
 */
export const useDiscardConversation = (): ((
  conversationId: string,
  organizationScope: SidekickActingOrganizationScope
) => Promise<void>) => {
  const [deleteConversation] =
    useConversationServiceDiscardConversationMutation();

  return useCallback(
    async (
      conversationId: string,
      organizationScope: SidekickActingOrganizationScope
    ): Promise<void> => {
      try {
        await deleteConversation({
          conversationId,
          organizationScope,
        }).unwrap();
      } catch (error) {
        if (import.meta.env.DEV) {
          console.warn(
            '[useDiscardConversation] failed to delete abandoned conversation',
            error
          );
        }
      }
    },
    [deleteConversation]
  );
};
